<template>
  <div class="map-preview">
    <router-link class="map-preview__map-link" :to="{ name: 'map' }">
      <span class="map-preview__map-link-title">
        {{ str('efriends.mapTitle') }}<br />
        {{ str('efriends.mapSubtitle') }}
      </span>
      <img
        class="map-preview__map-img"
        :src="$store.getters.mapPreviewImgUrl"
      />
    </router-link>
  </div>
</template>

<script>
  export default {
    name: 'map-preview',
    computed: {},
  }
</script>

<style lang="scss">
  .map-preview {
    text-align: center;

    &__map-img {
      max-width: 100%;
      transition: $transition-base;
      opacity: 0.8;
    }

    &__map-link {
      position: relative;
      display: inline-block;
      cursor: pointer;
      border: 1px solid $grey-lighter;
      border-radius: $border-radius;
      transition: $transition-base;

      @include hover-focus-active {
        .map-preview__map-img {
          opacity: 0.6;
        }
      }

      &-title {
        position: absolute;
        z-index: 1;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        color: $body-color;
        font-size: $font-size-xl;
        line-height: $line-height-min;
        width: 80%;
        padding: spacer(0.5) spacer(1);

        @media (min-width: $bp-lg) {
          border-radius: $border-radius;
        }
      }
    }
  }
</style>
